<template>
    <div class="seat-blank" :class="{'seat-blank': true, 'none': hide_seat}"></div>
</template>

<script>
import { isJHApp } from "../../utils/base"
export default {
    name: "seat",
    data () {
        return {
            hide_seat: true
        }
    },
    mounted () {
        if (!isJHApp()) {
            this.hide_seat = false
        }
    }
}
</script>
